// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".identifier-container{display:flex;flex-direction:column;height:100%;overflow:hidden}.p-datatable{table-layout:fixed;width:100%}", ""]);
// Exports
module.exports = exports;
